export default {
  status: {
    runtime: {
      completed: true,
    },
    errors: {
      data: {
        code: "",
        description: "",
      },
    },
  },
  response: {
    data: [
      {
        code: "2029000397240",
        description: "CORNETTI MBGR 240",
      },
      {
        code: "2029003105300",
        description: "CORNETTI FARCITI CREMA 300GR MB",
      },
      {
        code: "2029003110300",
        description: "CORNETTI FARCITI ALBICOCCA 300GR MB",
      },
      {
        code: "2029003995300",
        description: "CORNETTO CIOCCOLATO 300GR MB",
      },
      {
        code: "2029004478240",
        description: "CORNETTO INTEGRALE 240GR MB",
      },
      {
        code: "2010420001228",
        description: "SZA CORNETTI MV 228GR ",
      },
      {
        code: "2029004606300",
        description: "CORNETTI INTEGRALI FRUTTI ROSSI 300GR MB",
      },
      {
        code: "2029000996350",
        description: "PLUMCAKE GOCCE CIOC 350GR MB",
      },
      {
        code: "2010920001330",
        description: "PLUMCAKE YOGURT 330GR MB",
      },
      {
        code: "2029005177330",
        description: "PLUMCAKE INTEGR MB 330GR",
      },
      {
        code: "2010420002155",
        description: "SZA PLUMCAKE MV 155GR",
      },
      {
        code: "2029000625900",
        description: "SPICCHI DI SOLE BONUS PACK 900GR MB",
      },
      {
        code: "2029002468800",
        description: "GIROTONDI  BONUS PACK 800GR  MB",
      },
      {
        code: "2029003987700",
        description: "BISCOTTONE 700GR MB",
      },
      {
        code: "2029000605350",
        description: "TARALLUCCI 350GR MB",
      },
      {
        code: "2029000630350",
        description: "GALLETTI 350GR MB",
      },
      {
        code: "2029002468350",
        description: "GIROTONDI  350GR MB",
      },
      {
        code: "2029000640350",
        description: "MACINE 350GR MB",
      },
      {
        code: "2029000625400",
        description: "SPICCHI DI SOLE BONUS PACK 400GR MB",
      },
      {
        code: "2029000789350",
        description: "PANNOCCHIE 350GR",
      },
      {
        code: "2029000635400",
        description: "RIGOLI 400GR ",
      },
      {
        code: "2029000635800",
        description: "RIGOLI 800GR ",
      },
      {
        code: "2029000605800",
        description: "TARALLUCCI 800GR",
      },
      {
        code: "2029000640800",
        description: "MACINE 800GR",
      },
      {
        code: "2029000630800",
        description: "GALLETTI 800GR",
      },
      {
        code: "2029000905700",
        description: "CAMPAGNOLE 700GR",
      },
      {
        code: "2029003881700",
        description: "PRIMIZIE 700GR",
      },
      {
        code: "2029000169800",
        description: "MOLINETTI BONUS PACK 800GR",
      },
      {
        code: "2029005417350",
        description: "BUONGRANO MB 350GR",
      },
      {
        code: "9991000115330",
        description: "CIOCCOGRANO MB 330GR",
      },
      {
        code: "2029000169350",
        description: "MOLINETTI MB 350GR",
      },
      {
        code: "2029000660700",
        description: "RITORNELLI 700GR MB",
      },
      {
        code: "2029002666350",
        description: "BATTICUORI 350GR MB",
      },
      {
        code: "2029005114330",
        description: "NASCONDINI 330GR MB",
      },
      {
        code: "2029005114600",
        description: "NASCONDINI MB 600GR",
      },
      {
        code: "2029000708260",
        description: "BAIOCCHI NOCCIOLA 260GR MB",
      },
      {
        code: "2029000650700",
        description: "ABBRACCI 700GR ",
      },
      {
        code: "2029000650350",
        description: "ABBRACCI 350GR",
      },
      {
        code: "2029000661300",
        description: "CUOR DI MELA MB 300GR",
      },
      {
        code: "2010320001220",
        description: "CIOCCOAVENA MV 220GR",
      },
      {
        code: "2010320003220",
        description: "ZENZERINI MV 220GR",
      },
      {
        code: "2010320004200",
        description: "PANDIYO MV 200GR",
      },
      {
        code: "2010320002200",
        description: "CIOCCOFROLLE MV 200GR",
      },
      {
        code: "4011219001168",
        description: "BISCOCREMA 168GR",
      },
      {
        code: "4010818001350",
        description: "PAN DI STELLE 350GR",
      },
      {
        code: "4010818001700",
        description: "PAN DI STELLE 700GR",
      },
      {
        code: "2010720002300",
        description: "SCHIACCIANOCI 300GR",
      },
      {
        code: "2010920002250 ",
        description: "FROLLINO MIELE SENZA GLUTINE 250 GR",
      },
      {
        code: "2010920003250 ",
        description: "FROLLINO CIOCC. E RISO SENZA GLUTINE 250GR",
      },
    ],
  },
};